import React from 'react'
import { Link } from 'react-router-dom'
import './RegistrationLayout.css'

import { LOGO, SITE_NAME } from '@/utils'

const RegistrationLayout = (props) => {
    return (
        <section className="registrationCnt">
            <div className="registration">
                <div className="plBox">{props.children}</div>
            </div>
        </section>
    )
}

export default RegistrationLayout
